import { Component,Inject,inject,OnInit,signal,WritableSignal } from '@angular/core';
import { FormControl,ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute,Router,RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialog } from '../../dialogs/confirm.dialog';
import { AuthenticationService,LogServiceToken,RepositoryServiceToken } from '../../services';
import { CommunityAuthService } from '../../services/community-auth.service';
import { ILogService,IRepositoryService } from '../../services/i';
import {
BaseFilterViewModel,
RoleViewModel,
UserRoleViewModel,
UserViewModel
} from '../../view-models';
import { HeaderComponent } from '../header/header.component';


@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css'],
  imports: [
    HeaderComponent,
    MatToolbarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatListModule,
    RouterLink,
    MatButtonModule,
  ],
  standalone: true,
})
// Purpose: show (and edit) user details not visible in the list view.
// e.g. change user roles.
export class UserDetailsComponent implements OnInit {
  roles: RoleViewModel[];
  allRoles: RoleViewModel[];
  user: UserViewModel;
  userRoleControl: FormControl;
  dialogRef: MatDialogRef<ConfirmDialog>;
  public userFullName: WritableSignal<string> = signal('');
  private authenticationService: AuthenticationService = inject(AuthenticationService);
  private communityAuthService: CommunityAuthService = inject(CommunityAuthService);
  constructor(
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    @Inject(LogServiceToken) private log: ILogService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.userRoleControl = new FormControl();
  }

  ngOnInit() {
    // this.keywords.setValue("");
    const roleFilter = new BaseFilterViewModel();
    roleFilter.PageSize = 50;
    this.repo.Page(RoleViewModel, roleFilter).subscribe(roles => {
      this.allRoles = roles;
      this.roles = roles;
    });

    this.route.params.subscribe(params => {
      const id: number = +params['id'];
      this.refreshUser(id);
    });
  }

  openDialog(message: string): Promise<any> {
    this.dialogRef = this.dialog.open(ConfirmDialog, {
      disableClose: false,
    });
    this.dialogRef.componentInstance.title = 'Confirm Removal';
    this.dialogRef.componentInstance.message = message;

    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
    return this.dialogRef.afterClosed().toPromise();
  }

  refreshUser(id: number) {
    firstValueFrom(this.repo.Get(UserViewModel, id)).then( user => {
      try {
        this.user = user;
        const userRoleIds = (this.user?.UserRoles ?? []).map(
          (roleModel: UserRoleViewModel) => {
            return roleModel?.Role?.Id ?? -1;
          }
        );
        // userRoleIds should be an array of *just* the role ids for the user to make the filter easier
        this.roles = this.allRoles.filter(r => {
          return !userRoleIds.includes(r.Id);
        });
      } catch (error) {
        console.error(error);
      }
    });
  }

  removeUser() {
    this.openDialog(
      `Are you sure you want to remove ${this.user.FullName}?`
    ).then(confirm => {
      if (confirm) {
        firstValueFrom(this.repo.Delete(UserViewModel, this.user.Id)).then(result => {
            this.router.navigate(['/users']);
          })
          .catch(e => {
            this.log.warn('Error: ', e);
          });
      }
    });
  }

  removeRole(userRole: UserRoleViewModel) {
    this.openDialog(
      `Remove role ${userRole.Role.RoleName} from ${this.user.FullName}?`
    ).then(confirm => {
      if (confirm) {
        this.repo
          .Delete(UserRoleViewModel, userRole.Id)
          .toPromise()
          .then(ur => {
            this.refreshUser(this.user.Id);
          });
      }
    });
  }

  addRole() {
    const ur = new UserRoleViewModel();
    ur.UserId = this.user.Id;
    ur.RoleId = this.userRoleControl.value;
    if (!ur.RoleId) {
      return;
    }

    this.repo
      .Create(UserRoleViewModel, ur)
      .toPromise()
      .then(r => {
        this.refreshUser(this.user.Id);
      });
  }
}
